import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

import GlobalNav from '../../components/global-nav';
import ContentBlock from '../../components/content-block';

export default ({ data }) => {
  return (
    <main className="fxui-main">
      <Helmet>
        <meta charSet="utf-8"/>
        <title>FOX UI Kit</title>
        <link rel="stylesheet" href="/fox-bootstrap-kit/bootstrap.min.css"/>
      </Helmet>
      <GlobalNav data={data} />
      <section className="fxui-root fxui-is-bootstrap">
        {data.allMarkdownRemark.edges.map(({node}) => (
          <ContentBlock key={node.fields.slug} node={node}/>
        ))}
      </section>
    </main>
  );
}

export const query = graphql`
query {
  allMarkdownRemark(
    filter: {
      fileAbsolutePath: { regex: "/pages\/bootstrap/" }
    }
    sort: {
      fields: [fileAbsolutePath]
      order:ASC
    }
  ) {
    edges {
      node {
        fields {
          leaf,
          slug
        }
        frontmatter {
          title,
          leaf,
          contentClass
        }
        html
      }
    }
  }
}
`
